import { defineStore } from "pinia";
import { showError } from "src/utils/notify";

export const useshippingAddress = defineStore("shippingAddress", {
  state: () => ({
    address: [],
    loaddress: false,
    selectedShippingAddress: null
  }),
  getters: {},
  actions: {
    async getShippingAddress() {
      try {
        this.loaddress = false;
        this.address = [];
        let data = await this.$request.get(this.apiEndpoints.SHIPPING_ADDRESS);
        if (data.data) {
          this.address = data.data.items;
          this.loaddress = true;
        }
      } catch (error) {}
    },
    async removeAddress(id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.REMOVE_ADDRESS(id)
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    async editAddress(id, param) {
      try {
        let data = await this.$request.patch(
          this.apiEndpoints.UPDATE_ADDRESS(id),
          param
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    async createAddress(param) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.CREATE_ADDRESS,
          param
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {}
    },
    setSelectedShippingAddress(newVal) {
      this.selectedShippingAddress = newVal;
    }
  },
});
